<template>
	<div class="benefits">
		<h2 class="title">What Duckist does</h2>
		<div class="top-text">
			Duckist.com makes it easy to share passwords and other secret messages.
		</div>
		<ul class="list">
			<li class="item">

				<p>
					You can generate <span class="yellow-accent">one-time messages</span> that <br>
					<span class="yellow-accent">self-destruct</span>
				</p>
			</li>
			<li class="item">
				<p>
					Messages are <span class="yellow-accent">encrypted</span>
					on the frontend to ensure they are not even accessible to us
				</p>
			</li>
			<li class="item">
				<p class="">
					Sending secrets with <span class="green-accent">duckist.com</span>
					in e-mails/instant messengers protects them from potential attackers who would just see an expired link instead
				</p>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'Benefits',
	}
</script>

<style scoped lang="scss">
	@import "../assets/scss/benefits.scss";
</style>
